import { Component } from '@angular/core';

@Component({
  selector: 'app-awaiting-signer-acknowledgement',
  template: `
    <app-signing-room-dialog
      dialogTitle="All documents have been signed"
      message="Ask the signer(s) to acknowledge and submit on their screen. Once submitted, you'll be able to complete the session."
    />
  `,
  standalone: false,
})
export class AwaitingSignerAcknowledgementComponent {}
